// Imports
var ___HTML_LOADER_IMPORT_0___ = require("./@res/img/fcb-logo-property-pay-stack.svg");
// Module
var code = `<div appHeaderBar>
    <header-bar-title>Start Sso Login</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="sso-loading-container">
        <div class="sso-card">
            <div class="icon-wrapper">
                <img src="${___HTML_LOADER_IMPORT_0___}" alt="property-pay-icon" class="property-icon" />
            </div>

            <!--        <div class="custom-spinner"></div>-->

            <h1 class="status-title">{{ statusTitle }}</h1>
            <p class="status-message">{{ statusMessage }}</p>

            <div class="progress-bar">
                <div class="progress-bar-fill" [style.width.%]="progressValue"></div>
            </div>

        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;